// Canonical status values mirror backend `normalize_status` output.
export const STATUS_OPTIONS = [
    { value: "ready", label: "Ready Stock", tone: "success" },
    { value: "inden", label: "Inden / Pre-order", tone: "amber" },
    { value: "habis", label: "Habis", tone: "destructive" },
    { value: "discontinued", label: "Diskontinyu", tone: "muted" },
];

export const STATUS_BY_VALUE = Object.fromEntries(
    STATUS_OPTIONS.map((s) => [s.value, s])
);

export function getStatus(value) {
    return STATUS_BY_VALUE[value] || STATUS_OPTIONS[0];
}

// Tailwind classes per tone — keeps styling consistent everywhere.
export const STATUS_BADGE_CLASSES = {
    success: "bg-[hsl(var(--success))]/12 text-[hsl(var(--success))] border-[hsl(var(--success))]/30",
    amber: "bg-amber-500/15 text-amber-700 border-amber-500/30",
    destructive: "bg-destructive/12 text-destructive border-destructive/30",
    muted: "bg-secondary text-muted-foreground border-border",
};
